export enum BrandclubEventType {
    PageView = 'PageView',
    NavigateToRetailer = 'NavigateToRetailer',
    AddToCart = 'AddToCart',
    OrderSubmitted = 'OrderSubmitted',
}
// Add an interface for the tracking pixel structure
export interface TrackingPixel {
    pixelProvider: string;
    eventFilter?: string;
    eventMapping?: {
        pageView?: {
            enabled: boolean;
            mappedEventName: string;
        };
        addToCart?: {
            enabled: boolean;
            mappedEventName: string;
        };
        orderSubmitted?: {
            enabled: boolean;
            mappedEventName: string;
        };
        navigateToRetailer?: {
            enabled: boolean;
            mappedEventName: string;
        };
    };
    [key: string]: any;
}

export interface SimpleTrackingProvider {
    enableDebug: () => void;
    track: ({
        brandId,
        pixels,
        eventName,
        eventType,
        eventPayload
    }: {
        brandId: string;
        pixels: TrackingPixel[];
        eventName: string;
        eventType: BrandclubEventType;
        eventPayload: any;
    }) => void;
}